import { ApiClient } from '../ApiClient';
export default class SingleStampApiClient {
    constructor() {
        this.apiClient = new ApiClient('/api/single-stamps');
    }
    getStamps(filterData) {
        const params = new URLSearchParams(filterData);
        return this.apiClient.get(`?${params.toString()}`);
    }
}
